import { Component } from '@angular/core';
import {  Router } from '@angular/router';
import { OrdersService } from '../../../../services/orders';


@Component({
  selector: 'deliveryorders',
  templateUrl: './deliveryorders.component.html',
  styleUrl: './deliveryorders.component.scss'
})
export class DeliveryordersComponent {
  contentReady: boolean = true;
  selectedDeliveryOrders: any[] = [];
  constructor(private _router: Router,
        private ordersService: OrdersService
   ) { }

  ngOnInit() {
    this.contentReady = false;
    this.selectedDeliveryOrders = JSON.parse(localStorage.getItem('selectedDeliveryOrders') || '[]');

  }
deleteOrder(index: number) {
  // 1. شيل العنصر من المصفوفة
  this.selectedDeliveryOrders.splice(index, 1);

  // 2. حدّث الـ localStorage
  localStorage.setItem('selectedDeliveryOrders', JSON.stringify(this.selectedDeliveryOrders));
  if(localStorage.getItem('selectedDeliveryOrders') === '[]') {
        this._router.navigate(['/Orders']);
  }
}
 printAndSaveTodayOrders() {
    // لو مفيش أوردرات مختارة اطبع بس وخلاص
    if (!this.selectedDeliveryOrders || this.selectedDeliveryOrders.length === 0) {
      window.print();
      return;
    }

    // اسم التجميعة = تاريخ اليوم بس (مثلاً 2025-11-28)
    const todayName = new Date().toISOString().split('T')[0];

    // استخرج IDs من الـ selectedDeliveryOrders
    // 👈 لو الـ ID عندك اسمه حاجة تانية (order_id مثلاً) عدل السطر ده
    const ordersIds = this.selectedDeliveryOrders.map(o => o.id);

    this.ordersService.createTodayOrder(todayName, ordersIds).subscribe({
      next: (res) => {
        console.log('Today order saved:', res);
        window.print(); // اطبع بعد ما يتسجل في الداتابيز
      },
      error: (err) => {
        console.error('Error saving today order:', err);
        // حتى لو فشل، خليه يطبع عادي
        window.print();
      }
    });
  }

}
